var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iban-img-container"},[_c('v-img',{attrs:{"width":"30","src":require(`@/assets/img/banks/${parseInt(
        _vm.ibanObject?.iban?.slice(4, 7)
      )}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }